import { useState, useEffect, useCallback } from 'react';

export default function useMembersForm(stateSchema, validationSchema = {}, callback) {
  const [state, setState] = useState(stateSchema);
  const [disable, setDisable] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  // Disables button on initial render
  useEffect(() => {
    setDisable(true);
  }, []);

  // Disables button on changed state if necessary,
  // then sends the callback when the state is valid
  useEffect(() => {
    if (isDirty) {
      setDisable(validateState());
    }

    if (!validateState()) {
      setDisable(false);
      callback(state);
    }
  }, [state, isDirty]);

  // Disables the submit button if there's an error
  // or a required field in the state has no value.
  // useCallback prevents intensive memory leaks
  const validateState = useCallback(() => {
    const hasErrorInState = Object.keys(validationSchema).some((key) => {
      const isInputFieldRequired = validationSchema[key].required;
      const stateValue = state[key].value;
      const stateError = state[key].error;

      return (isInputFieldRequired && !stateValue) || stateError;
    });

    return hasErrorInState;
  }, [validationSchema]);

  // Used to handle input changes and submit the form
  const handleOnChange = useCallback((event) => {
    setIsDirty(true);

    const { name } = event.target;
    const { value } = event.target;

    let error = '';
    if (validationSchema[name].required) {
      if (!value) {
        error = 'This is required field.';
      }
    }

    if (
      validationSchema[name].validator != null
      && typeof validationSchema[name].validator === 'object'
    ) {
      if (value && !validationSchema[name].validator.formatTest(value)) {
        error = validationSchema[name].validator.error;
      }
    }

    setState((prevState) => ({
      ...prevState,
      [name]: { value, error },
    }));
  }, [validationSchema]);

  return { state, disable, handleOnChange };
}
